export const CREATE_STAFF = `
  mutation createStaff($input: CreateStaffInput!, $tenant_id: Int!) {
    createStaff(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Staff {
        id
        contact_id
        is_active
        contact {
          id
          firstname
          lastname
          email
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_STAFF = `
  mutation updateStaff($input: UpdateStaffInput!, $tenant_id: Int!) {
    updateStaff(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Staff {
        id
        contact_id
        is_active
        contact {
          id
          firstname
          lastname
          email
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_STAFF = `
  mutation deleteStaff($id: Int!, $tenant_id: Int!) {
    deleteStaff(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Staff {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
